const {
    ONLY_LETTERS_AND_SPACES_REGEX,
} = require('constants/index');


const typeOfInputs = {
    road: 'road',
    roadType: 'roadType',
    number: 'number',
    population: 'population',
    additionalInfo: 'additionalInfo',
}

const validationsForInputs = {
    [typeOfInputs.road]: {
        match: /^[A-Za-z0-9À-ÿ'_.\\?:;-\s\u00C7\u00E7\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA\u00B4]+$/i,
        length: 25,
    },
    [typeOfInputs.roadType]: {
        match: ONLY_LETTERS_AND_SPACES_REGEX,
        length: 22,
    },
    [typeOfInputs.number]: {
        match: /^S\/N$|^s\/n$|^[0-9]*$/,
        length: 4,
    },
    [typeOfInputs.population]: {
        match: /^[A-Za-zÀ-ÿ\\'çÇ-\s\u005B\u005D]+$/,
        length: 30,
    },
    [typeOfInputs.additionalInfo]: {
        match: /^([A-Za-z0-9À-ÿ'_.\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA\u00B4]+){0,}$/i,
        length: 10,
    },
}

const errors = {
    [typeOfInputs.road]: {
        INVALID_DATA: "step4RoadNameFieldInvalidError",
        EMPTY_DATA: "requiredFieldError",
    },
    [typeOfInputs.number]: {
        INVALID_DATA: "step4NumberFieldInvalid",
        EMPTY_DATA: "step4NumberFieldEmpty",
    },
    [typeOfInputs.population]: {
        INVALID_DATA: "step4RoadNameFieldInvalidError",
        EMPTY_DATA: "requiredFieldError",
    },
    [typeOfInputs.additionalInfo]: {
        INVALID_DATA: "step4AdditionalInfoInputInvalid",
        EMPTY_DATA: "step4AdditionalInfoRequiredInput",
    },
}

const selectAddresState = {
    selected: 'selected',
    no_selected: 'no selected',
    initial: '',
}

module.exports = {
    typeOfInputs,
    validationsForInputs,
    errors,
    selectAddresState,
};
